import { useMutation, useQuery, useQueryClient } from 'react-query'
import toast from 'react-hot-toast'

import { format, parseISO } from 'date-fns'

import { useAuth } from '../contexts/AuthContext'
import { api } from '../utils/api'

const useVR = ({ id }) => {
  const queryClient = useQueryClient()
  const { checkAccessToken } = useAuth()

  const getVRDraft = useQuery(
    ['getVRDraft'],
    async () => {
      await checkAccessToken()
      const { data } = await api.get(`/vrpassdown/draft`)
      return data
    },
    {
      onError: (error) =>
        error?.response.data.errors.forEach((err) => {
          toast.error(err.msg)
        }),
    }
  )

  const patchVRDraft = useMutation(
    async (values) => {
      if (values?.date) {
        if (typeof values.date == 'string') {
          values.date = format(
            parseISO(values.date),
            `yyyy-MM-dd'T'00:00:00.000-07:00`
          )
        } else {
          values.date = format(values.date, `yyyy-MM-dd'T'00:00:00.000-07:00`)
        }
      }

      const { data } = await api.patch(`/vrpassdown/draft/${id}`, values)
      return data
    },
    {
      onMutate: async (data) => {
        await queryClient.cancelQueries(['getVRDraft'])
        const previousValue = queryClient.getQueryData(['getVRDraft'])
        return previousValue
      },

      onError: (error, variables, previousValue) => {
        queryClient.setQueryData(['getVRDraft'], previousValue)
        error?.response.data.errors.forEach((err) => {
          toast.error(err.msg)
        })
        toast.error(
          'Because of the previous error data has been reverted to the last saved state, please try again'
        )
      },
      onSuccess: (data) => {
        toast.success(`Success: VR Passdown ${data._id} updated`)
      },
      onSettled: () => {
        queryClient.invalidateQueries(['getVRDraft'])
      },
    }
  )

  const postVREmailDraft = useMutation(
    async () => {
      const { data } = await api.post(`/vrpassdown/draft/email`)
      return data
    },
    {
      onMutate: async (data) => {
        await queryClient.cancelQueries(['getVRDraft'])
        const previousValue = queryClient.getQueryData(['getVRDraft'])
        return previousValue
      },
      onError: (error, variables, previousValue) => {
        queryClient.setQueryData(['getVRDraft'], previousValue)
        error?.response.data.errors.forEach((err) => {
          toast.error(err.msg)
        })
      },
      onSuccess: () => {
        toast.success(`Success: VR Passdown Email sent`)
      },
      onSettled: () => {
        queryClient.invalidateQueries(['getVRDraft'])
      },
    }
  )

  return {
    getVRDraft,
    patchVRDraft,
    postVREmailDraft,
  }
}

export default useVR
